let _nextLockId = 1;
const _activeLocks = new Set();

let _snapshot = null;

function _applyLockStyles() {
    const docEl = document.documentElement;
    const body = document.body;
    if (!docEl || !body || _snapshot) return;

    const scrollX = window.scrollX || window.pageXOffset || 0;
    const scrollY = window.scrollY || window.pageYOffset || 0;

    _snapshot = {
        scrollX,
        scrollY,
        docOverflow: docEl.style.overflow,
        docOverscroll: docEl.style.overscrollBehavior,
        bodyPosition: body.style.position,
        bodyTop: body.style.top,
        bodyLeft: body.style.left,
        bodyRight: body.style.right,
        bodyWidth: body.style.width,
        bodyOverflow: body.style.overflow,
        bodyOverflowY: body.style.overflowY,
        bodyOverscroll: body.style.overscrollBehavior,
    };

    docEl.classList.add('page-scroll-locked');
    body.classList.add('page-scroll-locked');

    docEl.style.overflow = 'hidden';
    docEl.style.overscrollBehavior = 'none';

    body.style.position = 'fixed';
    body.style.top = `-${Math.round(scrollY)}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    body.style.overflowY = 'hidden';
    body.style.overscrollBehavior = 'none';
}

function _restoreLockStyles() {
    const docEl = document.documentElement;
    const body = document.body;
    if (!docEl || !body || !_snapshot) return;

    const snap = _snapshot;
    _snapshot = null;

    docEl.classList.remove('page-scroll-locked');
    body.classList.remove('page-scroll-locked');

    docEl.style.overflow = snap.docOverflow || '';
    docEl.style.overscrollBehavior = snap.docOverscroll || '';

    body.style.position = snap.bodyPosition || '';
    body.style.top = snap.bodyTop || '';
    body.style.left = snap.bodyLeft || '';
    body.style.right = snap.bodyRight || '';
    body.style.width = snap.bodyWidth || '';
    body.style.overflow = snap.bodyOverflow || '';
    body.style.overflowY = snap.bodyOverflowY || '';
    body.style.overscrollBehavior = snap.bodyOverscroll || '';

    window.scrollTo({ left: snap.scrollX, top: snap.scrollY, behavior: 'auto' });
}

function _releaseLock(lockId) {
    if (!_activeLocks.delete(lockId)) return;
    if (_activeLocks.size === 0) {
        _restoreLockStyles();
    }
}

export function acquirePageScrollLock() {
    const lockId = _nextLockId++;
    _activeLocks.add(lockId);
    _applyLockStyles();
    return () => _releaseLock(lockId);
}

export function getPageScrollLockCount() {
    return _activeLocks.size;
}

export function clearPageScrollLocks() {
    if (_activeLocks.size === 0) return;
    _activeLocks.clear();
    _restoreLockStyles();
}
